import React from 'react';
import styled from 'styled-components';
import {useComponent} from '../component-library';

interface InputQuestionProps {
  text: string;
  additionalContent?: JSX.Element;
  infoButton: React.ReactNode;

  /**
   * for using question as a `<label htmlFor={labelledInputId}>`
   *
   * NOTE: If the referenced ID is a form input, this will usually make the
   * label interactive.
   */
  labelledInputId?: string;

  /** for referencing question as `aria-labelledby={questionTextId}` */
  questionTextId?: string;
  containerSpacingBottom?: boolean;
  children?: React.ReactNode;
}

export const InputQuestion: React.FC<InputQuestionProps> = (props) => {
  const {
    text,
    additionalContent,
    labelledInputId,
    children,
    questionTextId,
    infoButton,
    containerSpacingBottom = true,
  } = props;
  const Text = useComponent('Text');
  const questionText = (
    <Text variant="copy" tag="span" bold>
      {text}
    </Text>
  );

  return (
    <QuestionContainer containerSpacingBottom={containerSpacingBottom}>
      <QuestionLabel>
        <span id={questionTextId}>
          {labelledInputId ? (
            <label htmlFor={labelledInputId}>{questionText}</label>
          ) : (
            questionText
          )}

          {additionalContent && {...additionalContent}}
        </span>

        <HelpButtonContainer>
          {/*
              This is a (zero-width) word-joiner character.
              It is used as a hack to make all browsers glue the
              <HelpButtonContainer> to the last word of the text before, in
              regards to line-breaking.
              The same is used for a ReferenceBadge in components-core:
              https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-referencebadge--reference-badge#default
            */}
          &#8288;
          {infoButton}
        </HelpButtonContainer>
      </QuestionLabel>
      {children && <div>{children}</div>}
    </QuestionContainer>
  );
};

interface QuestionContainerProps {
  containerSpacingBottom: boolean;
}

const QuestionContainer = styled.div<QuestionContainerProps>`
  margin-bottom: ${(props) =>
    props.containerSpacingBottom
      ? props.theme.brand.spacing.inputSectionVerticalGap
      : 0};
`;

const QuestionLabel = styled.div`
  margin-bottom: ${(props) => props.theme.internal.size.static350};
`;

const HelpButtonContainer = styled.span`
  margin-inline-start: ${(props) => props.theme.internal.size.static100};
  white-space: nowrap;

  > * {
    vertical-align: middle;
  }
`;
